var spW = 768,    // SP max width, not contain
    isSp,         // Is SP or not
    winW,         // Window width
    winH,         // Window height
    winST,        // Window scrollTop
    isChange,     // Is change to PC/SP
    spaceImg = 'data:image/gif;base64,R0lGODlhAQABAJEAAAAAMwAAAP///wAAACH5BAEAAAIALAAAAAABAAEAAAICVAEAOw==';

$(function(){
  initCommon();
  initDevice();
  initLink();
  initMobileHover();
  initMenu();
  setLazyImg();

  $(window).load(function(){
    setTimeout(setLazyImg, 100);
  });

  $(window).scroll(function(){
    setScrolled();
  }).trigger('scroll');

  $(window).resize(function(){
    setTimeout(setLazyImg, 100);

    if (isChange) {
      $('.menu').css('transition', 'none');

      setTimeout(function(){
        $('.menu').css('transition', '');
        $('img').each(function(){
          $(this).attr('src', $(this).data('original'));
        });
      });

      initMenu();
    }
  });
});

function initCommon() {
  initHtml();
    $('body').addClass('fadeIn').data('showAll', true);
  $(window).load(function(){
    setTimeout(function(){
      setFadeInAnimOffset();
      $(window).resize(setFadeInAnimOffset);

      initLazyload();
      setFadeInAnim();
      initGray();

      $(window).scroll(setFadeInAnim);
      $(window).load(setFadeInAnim);
    });
    setTimeout(function(){
      $('body').data('showAll', false);
    }, 2000);

    $('body').addClass('loaded' + (isiPad ? ' ipad' : ''));
	ver = iOSversion();
	if (isiPad && ver && ver[0] == 9) {
    	$('body').addClass('ipadv9');
	}
  });

  $(window).scroll(function(){
    winST = $(window).scrollTop();
    initGray();
  }).trigger('scroll');

  $(window).resize(function(){
    getWinSize();
  }).trigger('resize');
}

function initHtml() {
  var svg = sessionStorage.getItem('svg');
  if(svg) {
    // TODO:エラーが出るため、一旦コメントアウト
    //  $('body').prepend('<div id="loadSvg" style="display: none">' + svg + '</div>');
   } else {
     /* global svg sprite loader removed for clean static build (was 404 on original site) */
    }
}

function getWinSize() {
  winW = $('html').css('overflow', 'hidden').width();
  winH = $(window).height();
  isChange = isSp !== undefined && isSp != (winW < spW);
  isSp = winW < spW;
  $('html').removeAttr('style');
}

function iOSversion() {
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
    return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
  }
}

function initDevice() {
  var userAgent = navigator.userAgent.toLowerCase();
  var pattern_phone = new RegExp('iphone', 'i');
  var pattern_android = new RegExp('Android', 'i');
  var isAndroid = pattern_android.test(userAgent);
  var isIphone = pattern_phone.test(userAgent);
  if (isAndroid) {
    $('body').addClass('Android');
  }
}

function initLink() {
  $('a').each(function(){
    var elm = $(this);
    // if (!isSp && this.protocol === 'tel:') elm.removeAttr('href').addClass('disable');
    if (this.hostname != location.hostname || elm.attr('target') == '_blank') return;
    if (this.pathname != location.pathname) {
      var _this = this;
      elm.click(function(){
        if (_this.pathname == '/') $('body').addClass('goTop');
        $('body').removeClass('fadeIn').removeClass('openMenu').addClass('closePage');
        setTimeout(function(){
          location.href = elm.attr('href');
        }, 700);
        return false;
      });
    } else {
      var target = $(this.hash);
      var duration = this.hash == '#main' ? 3000 : 1000;
      if(!target.length) return;
      elm.click(function(){
        var top = elm.hasClass('scrollUp') ? 0 : target.offset().top;
        if($('body').hasClass('index')){
          $('body').addClass('scrollHide');
          setFadeInAnimOffset();
        }
        $('html, body').stop().animate({
          // -100 is to show addressBar in iphone
          scrollTop: top ? top : -100
        }, {
          duration: duration,
          step: function (now, fx) {
            if(fx.prop == 'scrollTop') {
              var newTop = elm.hasClass('scrollUp') ? 0 : target.offset().top;
              fx.end = newTop ? newTop : -100;
            }
          },
          easing: 'easeOutQuart'
        });
        return false;
      });
    }
  });
}

function initLazyload() {
  if(!$('img.lazy').length) return;
  $('img.lazy').lazyload({
    threshold: winH,
    effect: 'fadeIn',
    effect_speed: 1000,
    failure_limit: 10,
    placeholder: spaceImg,
    load: function(){
      if (window.lazyloadCallback) lazyloadCallback();
    }
  });
}

function initMobileHover() {
  if (!isSp) return;
  $('.hover').on('touchstart', function() {
    $(this).addClass('touch');
  }).on('touchend', function() {
    $(this).removeClass('touch');
  });
}

function setScrolled() {
  if (winST > 0) {
    $('body').addClass('scrolled');
  } else {
    $('body').removeClass('scrolled');
  }
}

function setFadeInAnimOffset() {
  var fadeObj = $('.fadeInAnim');
  if (!fadeObj.length) return;
  fadeObj.each(function(){
    var elm = $(this),
    elmT = elm.offset().top;
    elm.data('offsetTop', elmT);
  });
}

var preWinST = 0;

function setFadeInAnim() {
  var fadeObj = $('.fadeInAnim');
  if (!fadeObj.length) return;

  var delayH = $('body').data('showAll') ? 0 : (isSp ? 54 : 50);
  var winST = $(window).scrollTop();
  var winH = $(window).height();

  fadeObj.each(function(){
    var elm = $(this);
    var elmT = elm.offset().top;

    if (winST <= preWinST && elm.hasClass('visible')) {
      if (winST < elmT - winH + delayH) {
        elm.removeClass('visible');
      }
    } else {
      if (winST > elmT - winH + delayH) {
        elm.addClass('visible');
      }
    }
  });

  preWinST = winST;
}

$(function(){
  setFadeInAnim();
  $(window).on('scroll load resize', setFadeInAnim);
});


function initMenu() {
  if (isSp || isiPad) {
    $('#gHeader #btnMenu, #gHeader .menu').unbind('mouseenter').unbind('mouseleave');

    $('#gHeader #btnMenu').unbind('click').click(function(){
      $('.menuList .menuList__item, .menuList2, .menu__faq__inst').css('transition', 'none');
      setTimeout(function(){
        $('.menuList .menuList__item, .menuList2, .menu__faq__inst').css('transition', '');
        $('body').toggleClass('openMenu');
      }, 50);
    });

    $('#gHeader .menu__first .header').unbind('mouseenter').unbind('mouseleave').click(function(){
      if (!$(this).next('.menuList__list').hasClass('on')) {
        $(this).next('.menuList__list').addClass('on').height($(this).next('.menuList__list').find('ul').outerHeight());
      } else {
        $(this).next('.menuList__list').removeClass('on').height(0);
      }
    });
  } else {
    var allowOpen = true;

    $('#gHeader #btnMenu').mouseenter(function(){
      if (!allowOpen) return;
      $('body').addClass('openMenu');
      $('#gHeader .menu').unbind('mouseleave').mouseleave(function(e){
        if (e.relatedTarget !== null) $('body').removeClass('openMenu');
      });
    });

    $('#gHeader #btnMenu').unbind('click').click(function(){
      allowOpen = false;
      $('body').removeClass('openMenu');
      $('#gHeader #btnMenu, #gHeader .menu').unbind('mouseleave');
      setTimeout(function(){
        allowOpen = true;
      }, 500);
    });

    $('#gHeader .menu__first .header').unbind('click').mouseenter(function(){
      if ($(this).next('.menuList__list').height() != 0) return;
      $(this).next('.menuList__list').addClass('on').height($(this).next('.menuList__list').find('ul').outerHeight());
    });
  }

  $('#gFooter .menu__first .header').unbind('click').click(function(){
    if (!$(this).next('.menuList__list').hasClass('on')) {
      $(this).next('.menuList__list').addClass('on').height($(this).next('.menuList__list').find('ul').outerHeight());
    } else {
      $(this).next('.menuList__list').removeClass('on').height(0);
    }
  });
}

function setLazyImg() {
  if (!$('img.lazy').length) return;
  $('img.lazy').each(function(){
    if ($(this).attr('src') == $(this).data('original')) {
      $(this).width('').height('');
    } else {
      if (!$(this).attr('src')) $(this).attr('src', spaceImg);
      var size = $(this).data('size');
      if (!size) return;
      size = size.split('x');
      var w = $(this).parent().width();
      $(this).width(w).height(size[1] / size[0] * w);
    }
  });
}

// function initGray() {
//   if (!$('.gray').length) return;
//   var delayH = winH / 5 + 20;
//   $('.gray').each(function(){
//     var elm = $(this),
//     elmT = elm.offset().top,
//     elmH = elm.height();

//     if (winST > elmT - winH + delayH && winST < elmT + elmH) {
//       elm.addClass('show');
//     } else if (winST < elmT - winH + delayH && winST < elmT + delayH) {
//       elm.removeClass('show');
//     }
//   });
// }
function initGray() {
  const targets = document.querySelectorAll('.gray');
  if (!targets.length) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('show');
      } else {
        entry.target.classList.remove('show');
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -20% 0px',
    threshold: 0.1
  });
  targets.forEach(el => observer.observe(el));
}


function loadImg(elem) {
  $(elem).each(function(){
    var _this = $(this);
    if (_this.data('loaded')) return;

    if(_this.find('.loadSliderPic').length > 0 && isSp) {
      var swiperFadeIn = true;
      var swiperTop = 400;
    } else {
      var swiperFadeIn = false;
      var swiperTop = 0;
    };

    if (winST > _this.offset().top - winH - 100 - swiperTop) {
      _this.find('img').each(function(){
        if (!$(this).data('original')) return;
        $(this).attr('src', $(this).css('opacity', 0).data('original')).load(function(){
          $(this).stop().animate({opacity: 1}, 500);
          if(swiperFadeIn) {
            $(this).parent().addClass('swiperFadeIn')
          }
          if ($.fn.matchHeight) $.fn.matchHeight._update();
          setCenter();
        });
      });
      _this.data('loaded', true);

    } else {
      _this.find('img').each(function(){
        if ($(this).data('original')) $(this).attr('src', spaceImg);
      });
    }
  });
}

function initMySlider(elem, opt) {
  var $slider = typeof(elem) === 'string' ? $(elem) : elem;
  if (!$slider.length) return;

  var $slides = $(elem).children();
  if ($slides.length <= 1) return;

  var defaults = {
    swipeElem: '',
    onChange: null,
    btnPrev: null,
    btnNext: null,
    pointer: null,
    onlySp: true,
    swipePc: true,
    autoHeight: false,
    autoPlay: false,
    allowSwipe: true,
    touchMove: true
  };
  var options = $.extend({}, defaults, opt);
  var curIndex = 0;
  var moving = false;
  var $swipeElem = options.swipeElem ? (typeof(options.swipeElem) === 'string' ? $(options.swipeElem) : options.swipeElem) : null;

  if (options.onlySp && !isSp) {
    destory();
    return;
  }

  init();

  function init() {
    $slider.addClass('mySlider');
    $slides.addClass('slideItem');
    $slides.eq(curIndex).addClass('current');
    if (isSp || options.swipePc) {
      initSwipe($slider);
      initSwipe($swipeElem);
    }

    if (options.btnPrev || options.btnNext) {
      options.btnPrev.click(prev);
      options.btnNext.click(next);
    }

    if (options.pointer) {
      options.pointer.click(function(){
        to($(this).index());
      });
    }

    if (options.autoHeight) {
      $('<img>').attr('src', $slides.eq(0).find('img').data('original')).load(function(){
        $slider.css('padding-bottom', this.height / this.width * 100 + '%');
      });
    }

    if (options.autoPlay) setTimeout(next, 3000);
  }

  function to(newCurIndex) {
    if (newCurIndex == curIndex) return;
    newCurIndex < curIndex ? prev(newCurIndex) : next(newCurIndex);
  }

  function prev(index) {
    if (moving) return;
    moving = true;

    var newCurIndex = typeof(index) === 'number' ? index : (($slides.length + curIndex - 1) % $slides.length);
    var oldSlide = $slides.eq(curIndex);
    var newSlide = $slides.eq(newCurIndex);
    newSlide.addClass('prev');
    if (typeof(options.onChange) === 'function') options.onChange(newCurIndex, $slider, options.pointer);
    if (options.autoPlay) setTimeout(next, 3000);

    setTimeout(function(){
      oldSlide.removeClass('current moveCurrent').addClass('moveNext');
      newSlide.removeClass('prev').addClass('current moveCurrent');
      curIndex = newCurIndex;
    }, 50);

    if(isSp && $slider.parents().hasClass('tourSwiperChangePic')) {
      setTimeout(function(){
        oldSlide.removeClass('moveNext');
        moving = false;
      }, 500);
    } else {
      setTimeout(function(){
        oldSlide.removeClass('moveNext');
        moving = false;
      }, 1000);
    }

  }

  function next(index) {
    if (moving) return;
    moving = true;

    var newCurIndex = typeof(index) === 'number' ? index : ((curIndex + 1) % $slides.length);
    var oldSlide = $slides.eq(curIndex);
    var newSlide = $slides.eq(newCurIndex);
    newSlide.addClass('next');
    if (typeof(options.onChange) === 'function') options.onChange(newCurIndex, $slider, options.pointer);
    if (options.autoPlay) setTimeout(next, 3000);

    setTimeout(function(){
      oldSlide.removeClass('current moveCurrent').addClass('movePrev');
      newSlide.removeClass('next').addClass('current moveCurrent');
      curIndex = newCurIndex;
    }, 50);

    if(isSp && $slider.parents().hasClass('tourSwiperChangePic')) {
      setTimeout(function(){
        oldSlide.removeClass('movePrev');
        moving = false;
      }, 500);
    } else {
      setTimeout(function(){
        oldSlide.removeClass('movePrev');
        moving = false;
      }, 1000);
    }

  }

  function initSwipe(target) {
    if (!options.allowSwipe || !target) return;
    var startX, endX, startY, endY, moving, allowScroll;
    var _this = this;

    target.on('touchstart', function(e){
      allowScroll = true;
      moving = true;
      startX = e.originalEvent.changedTouches[0].pageX;
      startY = e.originalEvent.changedTouches[0].pageY;
    }).on('touchmove', function(e){
      endX = e.originalEvent.changedTouches[0].pageX;
      endY = e.originalEvent.changedTouches[0].pageY;
      if (allowScroll && Math.abs(endY - startY) / Math.abs(endX - startX) < 0.9) allowScroll = false;
      if (!allowScroll) e.preventDefault();
    }).on('touchend', function(){
      moving = false;
      if (Math.abs(endX - startX) < 100) return;
      if(startX > endX) {
        next();
      } else if(startX < endX) {
        prev();
      }
    }).on('mousedown', function(e){
      startX = e.pageX;
    }).on('mouseup', function(e){
      endX = e.pageX;
      if (Math.abs(endX - startX) < 100) return;
      if (startX > endX) {
        next();
      } else if(startX < endX) {
        prev();
      }
    });
  }

  function destory() {
    $slider.removeClass('mySlider').unbind('mousedown mouseup touchstart touchend');
    $slides.removeClass('slideItem current prev next moveCurrent movePrev moveNext');
    if ($swipeElem) $swipeElem.unbind('mousedown mouseup touchstart touchend');
  }
}

function setCenter() {
  $('.center').each(function(){
    var text = $(this).parent();
    text = text.hasClass('position') ? text.parent() : text;
    var pic = text.siblings().eq(0);
    $(this).parent().height(isSp ? '' : pic.outerHeight());
  });
}

$(function(){
  $('.nav-open').on('click',function(){
    $(this).toggleClass('active');
    $(this).next('nav').slideToggle();
  });
});


$(window).on("scroll", function(){
  $("header").css("left", -$(window).scrollLeft());
  $(".nav").css("left", -$(window).scrollLeft());
});

$(function() {
  const fh = document.getElementById('_CTA');
  window.addEventListener('scroll', () => {
    if (window.pageYOffset > 20) {
      fh.classList.add('is-show');
    } else {
      fh.classList.remove('is-show');
    }
  });
}());

/*------------------------------------------------------------
  新ヘッダー・新メニュー・新フッター
------------------------------------------------------------*/
$(function() {
  var status = 0;
  $('.drawer').on('click', function () {
    $('.navbar_toggle').toggleClass('open');
    $('.drawermenubg').toggleClass('open');
    $('.drawermenu').toggleClass('open');
    $('body').toggleClass('open');
    $('.drawermenu').scrollTop(0);
                                status += 1;
                                if( status == 2 ) {
                                                status = 0;
                                }
  });
                $(document).on('click',function(e) {
                               if( status % 2 === 0 ) {
                                                // 偶数の場合の処理
                                }else{
                                                if(!$(e.target).closest('.drawermenu').length) {
                                                                if(!$(e.target).closest('.nav').length) {
                                                    $('.navbar_toggle').removeClass('open');
                                                    $('.drawermenubg').removeClass('open');
                                                    $('.drawermenu').removeClass('open');
                                                    $('body').removeClass('open');
                                                                                status = 0;
                                                                } else {
                                                                }
                                                } else {
                                                }
                                }
                });
}());
